var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-end",class:{'text-text-ternary':_vm.value === 0,
              'text-red':_vm.value < 0}},[_c('div',[_vm._v(_vm._s(_vm.formattedCurrencyValue(_vm.value)))]),_c('div',{staticClass:"w-20 ml-4",class:{'text-green':_vm.percent > 0,
                'text-red':_vm.percent < 0}},[_vm._v(" "+_vm._s(_vm.percent)+" % ")])])}
var staticRenderFns = []

export { render, staticRenderFns }